import React from 'react';

import Loading from '../Loading';
import {
	Overlay,
	ModalCard,
	ModalHeader,
	ModalTitle,
	ModalContent,
	ModalLoadingWrapper
} from './Modal.styles';

function Modal({ isOpen, onClose, title, content, loading }) {
	if (!isOpen) {
		return null;
	}

	return (
		<Overlay onClick={onClose}>
			<ModalCard onClick={e => e.stopPropagation()}>
				<ModalHeader>
					<ModalTitle>{title}</ModalTitle>
					<button
						className="doca-button doca-button--tertiary doca-button--small"
						onClick={onClose}
						aria-label="Fechar modal"
					>
						<i className="doca-icon doca-icon__xmark" />
					</button>
				</ModalHeader>

				<ModalContent>
					{loading ? (
						<ModalLoadingWrapper>
							<Loading />
						</ModalLoadingWrapper>
					) : (
						<div dangerouslySetInnerHTML={{ __html: content }} />
					)}
				</ModalContent>
			</ModalCard>
		</Overlay>
	);
}

export default Modal;
